import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=282ea625"
import script from "./DashboardCharts.vue?vue&type=script&lang=js"
export * from "./DashboardCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports